module.exports = __webpack_public_path__ + "ff8256fa588b4c2161220e7a6193ada6.pdf";